"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _ButtonGroup = require("./ButtonGroup.context");
var _ButtonGroup2 = require("./ButtonGroup.styles");
var _excluded = ["buttonType", "fluid", "size"];
/**
 * Be sure to add an appropriate
 * [aria-label](https://www.w3.org/TR/wai-aria-1.2/#aria-label) for assistive technologies.
 *
 * @related ['Button', 'LoadingButton', 'TextButton', 'ToggleButton']
 * @since 5.0.0
 */
var ButtonGroup = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var buttonType = _ref.buttonType,
    fluid = _ref.fluid,
    size = _ref.size,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroupContext.Provider, {
    value: {
      buttonType: buttonType,
      fluid: fluid,
      size: size
    }
  }, /*#__PURE__*/_react.default.createElement(_ButtonGroup2.StyledButtonGroup, (0, _extends2.default)({
    ref: forwardedRef,
    fluid: fluid
  }, rest)));
});
exports.ButtonGroup = ButtonGroup;
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.propTypes = {
  /**
   * An [aria-label](https://www.w3.org/TR/wai-aria-1.2/#aria-label) is required for assistive
   * technologies to announce the button group properly.
   */
  'aria-label': _propTypes.default.string.isRequired,
  /**
   * Sets `buttonType` for all `Button` children.
   */
  'buttonType': _propTypes.default.oneOf(Object.values(_constants.BUTTON_TYPES)),
  /**
   * Connect the buttons by removing the space between buttons in the group. In general, you will
   * only want to do this with buttons of the same type. You can use `buttonType` to set the type
   * to be the same for all buttons.
   */
  'conjoined': _propTypes.default.bool,
  /**
   * The direction in which the buttons should be aligned. Buttons will be fluid when the
   * direction is set to `column`.
   *
   * Supports inline media query objects
   */
  'direction': _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse'])),
  /**
   * The button group will expand to fill its parent container.
   *
   * Supports inline media query objects
   */
  'fluid': _customPropTypes.default.inlineMediaQuery(_propTypes.default.bool),
  /**
   * Sets the `role` of the button group. By default, this is set to
   * ["group"](https://www.w3.org/TR/wai-aria-1.2/#group), but "toolbar" might be more
   * appropriate if the button group is used in a toolbar.
   */
  'role': _propTypes.default.string,
  /**
   * Sets `size` for all `Button` children.
   */
  'size': _propTypes.default.oneOf(Object.values(_constants.BUTTON_SIZES))
};
ButtonGroup.defaultProps = {
  direction: 'row',
  role: 'group'
};